import React, { useState, useEffect, useCallback } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { FaThumbsUp, FaTools, FaInfoCircle, FaArrowLeft } from "react-icons/fa";
import Grid from "./MainGrid";
import IntentsFilter from "./IntentsFilter";
import Tools from "../utils/Tools";
import { useFilter } from '../FilterContext';

function IntentView() {
  const { intentName } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [agent, setAgent] = useState(null);
  const [rowData, setRowData] = useState([]);
  const { filters, setFilters } = useFilter();
  const [loading, setLoading] = useState(true);
  const [loadingSummary, setLoadingSummary] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showTrends, setShowTrends] = useState(false);
  const [sortModel, setSortModel] = useState([]);
  useState(false);

  const canGoBack = window.history.length > 1;

  const handleGoBack = () => {
    navigate(location.state?.referrer || -1);
  };

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1); // Reset to first page on filter change
  }, []);

  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  const handleSortChange = useCallback((newSortModel) => {
    setSortModel(newSortModel);
  }, []);

  /*useEffect(() => {
    setLoadingSummary(true);
    Tools.sendRequest("get-intent", {
      intentName: intentName,
      dateRange: filters.dateRange.value,
    }).then((response) => {
      setAgent(response);
      setLoadingSummary(false);
    });
  }, [intentName, filters.dateRange]);*/

  useEffect(() => {
    setLoading(true);
    const queryParams = new URLSearchParams();

    queryParams.append("minorIntents", intentName);

    if (filters.dateRange) {
      queryParams.append("dateRange", filters.dateRange.value);
    }
    if (!filters.excludeWeekends) {
      queryParams.append("excludeWeekends", filters.excludeWeekends);
    }
    queryParams.append("page", currentPage);

    if (sortModel && sortModel.length > 0) {
      sortModel.forEach((sortItem) => {
        queryParams.append('sortBy', sortItem.colId);
        queryParams.append('sortOrder', sortItem.sort);
      });
    }

    Tools.sendRequest("get-data", queryParams.toString()).then((response) => {
      console.log("DEBUG - GOT DATA", response);
      setRowData(response.data);
      setTotalRecords(response.totalRecords);
      setTotalPages(response.totalPages);
      setCurrentPage(response.currentPage);
      setLoading(false); // Data fetching is complete
    });
  }, [currentPage, filters, intentName, sortModel]);

  return (
    <div>
      <div className="flex justify-between items-center mb-4 max-w-screen-xl mx-auto">
        <div className="w-1/3">
          {canGoBack && (
            <button
              onClick={handleGoBack}
              className="text-sm text-gray-600 hover:text-gray-800 flex items-center"
            >
              <FaArrowLeft className="mr-1" /> Back
            </button>
          )}
        </div>
        <h2 className="text-2xl font-bold text-center w-1/3">{intentName}</h2>
        <div className="w-1/3 flex justify-end mr-10"></div>
      </div>

      <div className="container mx-auto p-4">
        <IntentsFilter
          filters={filters}
          setFilters={handleFilterChange}
        />
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="loader"></div>
          </div>
        ) : (
          <>
            <Grid
              data={rowData}
              currentPage={currentPage}
              totalPages={totalPages}
              totalRecs={totalRecords}
              onPageChange={handlePageChange}
              onSortChange={handleSortChange}
              filters={filters}
              sortModel={sortModel}  // Pass sortModel to Grid
            />
          </>
        )}
      </div>
    </div>
  );
}

export default IntentView;
